import { render, staticRenderFns } from "./SemcogHeader.vue?vue&type=template&id=72cd8c4f&scoped=true&"
import script from "./SemcogHeader.vue?vue&type=script&lang=js&"
export * from "./SemcogHeader.vue?vue&type=script&lang=js&"
import style0 from "./SemcogHeader.vue?vue&type=style&index=0&id=72cd8c4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cd8c4f",
  null
  
)

export default component.exports